/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ShiftiePlainDate } from './ShiftiePlainDate';
import {
    ShiftiePlainDateFromJSON,
    ShiftiePlainDateFromJSONTyped,
    ShiftiePlainDateToJSON,
    ShiftiePlainDateToJSONTyped,
} from './ShiftiePlainDate';

/**
 * 
 * @export
 * @interface UpdateDocumentData
 */
export interface UpdateDocumentData {
    /**
     * 
     * @type {string}
     * @memberof UpdateDocumentData
     */
    name?: string;
    /**
     * Whether the document should be visible to all employees
     * @type {boolean}
     * @memberof UpdateDocumentData
     */
    visibleToAll?: boolean;
    /**
     * These employees should be able to view this document
     * @type {Array<number>}
     * @memberof UpdateDocumentData
     */
    employeeIds?: Array<number> | null;
    /**
     * Employees with these job roles should be able to view this document
     * @type {Array<number>}
     * @memberof UpdateDocumentData
     */
    jobRoleIds?: Array<number> | null;
    /**
     * Indicates whether the document must be read by employees, and if so, by when
     * @type {Date}
     * @memberof UpdateDocumentData
     */
    readDeadline: Date | null;
    /**
     * Provide a new upload ID to create a new version of the document
     * @type {number}
     * @memberof UpdateDocumentData
     */
    uploadId?: number;
    /**
     * Indicates whether the document must be accepted by employees
     * @type {boolean}
     * @memberof UpdateDocumentData
     */
    acceptanceRequired?: boolean | null;
    /**
     * The date when the document expires
     * @type {ShiftiePlainDate}
     * @memberof UpdateDocumentData
     */
    expiryDate?: ShiftiePlainDate | null;
}

/**
 * Check if a given object implements the UpdateDocumentData interface.
 */
export function instanceOfUpdateDocumentData(value: object): value is UpdateDocumentData {
    if (!('readDeadline' in value) || value['readDeadline'] === undefined) return false;
    return true;
}

export function UpdateDocumentDataFromJSON(json: any): UpdateDocumentData {
    return UpdateDocumentDataFromJSONTyped(json, false);
}

export function UpdateDocumentDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateDocumentData {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'visibleToAll': json['visibleToAll'] == null ? undefined : json['visibleToAll'],
        'employeeIds': json['employeeIds'] == null ? undefined : json['employeeIds'],
        'jobRoleIds': json['jobRoleIds'] == null ? undefined : json['jobRoleIds'],
        'readDeadline': (json['readDeadline'] == null ? null : new Date(json['readDeadline'])),
        'uploadId': json['uploadId'] == null ? undefined : json['uploadId'],
        'acceptanceRequired': json['acceptanceRequired'] == null ? undefined : json['acceptanceRequired'],
        'expiryDate': json['expiryDate'] == null ? undefined : ShiftiePlainDateFromJSON(json['expiryDate']),
    };
}

  export function UpdateDocumentDataToJSON(json: any): UpdateDocumentData {
      return UpdateDocumentDataToJSONTyped(json, false);
  }

  export function UpdateDocumentDataToJSONTyped(value?: UpdateDocumentData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'visibleToAll': value['visibleToAll'],
        'employeeIds': value['employeeIds'],
        'jobRoleIds': value['jobRoleIds'],
        'readDeadline': (value['readDeadline'] == null ? null : (value['readDeadline'] as any).toISOString()),
        'uploadId': value['uploadId'],
        'acceptanceRequired': value['acceptanceRequired'],
        'expiryDate': ShiftiePlainDateToJSON(value['expiryDate']),
    };
}

